import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AlertService } from "src/app/services/alert.service";
import { FarmerService } from "src/app/services/farmer.service";
import { Router } from "@angular/router";
import { EventType } from "src/enum/eventtype";
import * as moment from "moment";
import { BankcityService } from "src/app/services/bankcity.service";

// Subsidy release by AEE, to the farmer (target-flow step 7). See CLAUDE.md for design rationale.
@Component({
  selector: "app-subsidyreleasetofarmerpopup",
  templateUrl: "./subsidyreleasetofarmerpopup.component.html",
  styleUrls: ["./subsidyreleasetofarmerpopup.component.scss"],
})
export class SubsidyReleaseToFarmerPopupComponent implements OnInit {
  form: FormGroup;
  id: any;
  isShow: boolean;
  filterCityName: any = [];
  bankName: any;
  bankNameList: any;
  filterbranchName: any[] = [];
  branchName: any[] = [];
  CityName: any[] = [];
  public eventEnum = EventType;
  today: Date;
  Amountvalid: boolean = false;
  isdisabled: boolean = false;
  maxDate: Date;
  minDate: Date;
  bookedTs: any;
  lowSubsidy: boolean = false;
  acNodisable: boolean;
  totalSubsidyAmount: any;
  loading: boolean = false;
  stateList: any[];
  filterstateList: any[];

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private farmerService: FarmerService,
    private router: Router,
    public dialogRef: MatDialogRef<SubsidyReleaseToFarmerPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public addServiceDialog: MatDialog,
    private bankcityService: BankcityService
  ) {
    this.id = this.dataRecievedData.sessionId;
    this.bookedTs = this.dataRecievedData.bookedTs;
    this.totalSubsidyAmount = this.dataRecievedData.totalSubsidyAmount;
  }

  ngOnInit(): void {
    this.getState();
    this.initializeValidators();
    this.maxDate = new Date();
    this.minDate = new Date(moment(this.bookedTs).format("YYYY, MM, DD"));
    if (this.dataRecievedData?.session?.ifsc) {
      this.form.controls["ifscCode"].setValue(this.dataRecievedData.session.ifsc);
    }
    if (this.dataRecievedData?.session?.acNo) {
      this.acNodisable = true;
      this.form.controls["accountNo"].setValue(this.dataRecievedData?.session?.acNo);
    }
    if (this.dataRecievedData?.session?.farmerAccountHolderName) {
      this.form.controls["accountName"].setValue(this.dataRecievedData.session.farmerAccountHolderName);
    }
    if (this.dataRecievedData?.latitude && this.dataRecievedData?.longitude) {
      this.form.controls["latitude"].setValue(this.dataRecievedData?.latitude);
      this.form.controls["longitude"].setValue(this.dataRecievedData?.longitude);
    }
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      dateofTransfer: ["", Validators.required],
      subsidyAmount: ["", Validators.required],
      transferRefNumber: ["", Validators.required],
      utrNumber: [""],
      state: ["", Validators.required],
      bankName: ["", Validators.required],
      ifscCode: ["", Validators.required],
      accountNo: ["", Validators.required],
      accountName: ["", Validators.required],
      branch: ["", Validators.required],
      City: ["", Validators.required],
      latitude: [null],
      longitude: [null],
    });
  }

  next() {
    this.dialogRef.close();
    this.router.navigate(["/aeefarmerbookingview"]);
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  getState() {
    this.bankcityService.getState(true).subscribe((res) => {
      this.stateList = [];
      this.filterstateList = [];
      this.stateList = res;
      this.filterstateList = this.stateList.slice();
      this.form.controls["state"].setValue(31);
      this.getbankname();
    });
  }

  onSubmit() {
    if (this.form.valid) {
      if (this.form.value.subsidyAmount == this.totalSubsidyAmount) {
        this.isdisabled = true;
        let request = {
          id: this.id,
          dbtSchemeId: null,
          dbtComponentId: null,
          dbtProductId: null,
          dbtProductInfoId: null,
          dbtManufacturerId: null,
          dbtDealerId: null,
          farmerBankDetailId: this.dataRecievedData?.session?.farmerBankDetailId || null,
          eventType: this.eventEnum.SubsidyReleaseToFarmer,
          bankId: this.form.value.bankName,
          branchId: this.form.value.branch,
          cityId: this.form.value.City,
          ifsc: this.form.value.ifscCode.toString(),
          acNo: this.form.value.accountNo.toString(),
          accountHolderName: this.form.value.accountName.toString(),
          transactionType: 0,
          paymentTs: moment(this.form.value.dateofTransfer).format("YYYY-MM-DD"),
          receiptNumber: this.form.value.transferRefNumber,
          productCost: 0,
          gstPercentage: 0,
          subsidyAmount: this.form.value.subsidyAmount,
          totalCost: 0,
          deliveryTs: moment(this.form.value.dateofTransfer).format("YYYY-MM-DD"),
          remarks: "",
          utrNumber: this.form.value.utrNumber,
          attachment: [],
          latitude: this.form.value.latitude || 0,
          longitude: this.form.value.longitude || 0,
        };
        this.farmerService.farmerSave(request).subscribe((res) => {
          if (res && res.isSuccess) {
            this.isdisabled = false;
            this.alertService.success("Successfully released the subsidy to the farmer.");
            this.dialogRef.close();
            this.router.navigate(["/aeefarmerbooking"]);
          } else {
            this.isdisabled = false;
          }
        });
      } else {
        this.alertService.warning("Subsidy Amount Is Mismatched.");
      }
    } else {
      this.isdisabled = false;
      this.validateFormControl();
      this.alertService.error("Please fill the required fields .");
    }
  }

  getbankname() {
    this.filterCityName = [];
    this.bankName = [];
    this.bankNameList = [];
    this.CityName = [];
    this.branchName = [];
    this.filterbranchName = [];
    this.form.controls["ifscCode"].setValue(null);
    this.form.controls["branch"].setValue(null);
    this.form.controls["City"].setValue(null);
    this.form.controls["bankName"].setValue(null);
    this.bankcityService.getBank(this.form.value.state, true).subscribe((res) => {
      this.bankName = res.filter((i: { key: number }) => i.key);
      this.bankNameList = this.bankName;
      if (this.bankNameList.length == 1) {
        this.form.controls["bankName"].setValue(this.bankNameList[0].key);
        this.getcity();
      }
      if (this.dataRecievedData?.session?.farmerBankId > 0) {
        this.form.controls["bankName"].setValue(this.dataRecievedData?.session?.farmerBankId);
        this.getcity();
      }
    });
  }

  getcity() {
    this.filterCityName = [];
    this.CityName = [];
    this.branchName = [];
    this.filterbranchName = [];
    this.bankcityService.getCity(this.form.value.state, this.form.value.bankName, true).subscribe((res) => {
      this.CityName = res;
      this.filterCityName = this.CityName;
      this.form.controls["branch"].setValue(null);
      this.form.controls["ifscCode"].setValue(null);
      if (this.CityName.length == 1) {
        this.form.controls["City"].setValue(this.CityName[0].key);
        this.getbranch();
      }
      if (this.dataRecievedData?.session?.farmerCityId > 0) {
        this.form.controls["City"].setValue(this.dataRecievedData?.session?.farmerCityId);
        this.getbranch();
      }
    });
  }

  getbranch() {
    this.branchName = [];
    this.filterbranchName = [];
    this.farmerService.getbranch(this.form.value.City, true).subscribe((res) => {
      this.branchName = res;
      this.filterbranchName = this.branchName;
      this.form.controls["ifscCode"].setValue(null);
      if (this.branchName.length == 1) {
        this.form.controls["branch"].setValue(this.branchName[0].key);
        this.ifscno(this.form.value.branch);
      }
      if (this.dataRecievedData?.session?.farmerBranchId > 0) {
        this.form.controls["branch"].setValue(this.dataRecievedData?.session?.farmerBranchId);
        this.ifscno(this.form.value.branch);
      }
    });
  }

  ifscno(event: any) {
    var list = this.filterbranchName.filter((i) => i.key == this.form.value.branch);
    this.form.controls["ifscCode"].setValue(list.length ? list[0].ifsc : null);
  }

  // Typing a full 11-character IFSC patches bank, city and branch; each can still be changed afterwards
  onIfscInput() {
    const ifsc = (this.form.value.ifscCode || "").toString().trim().toUpperCase();
    if (ifsc !== this.form.value.ifscCode) {
      this.form.controls["ifscCode"].setValue(ifsc, { emitEvent: false });
    }
    if (ifsc.length !== 11) { return; }
    this.bankcityService.getIfscDetails(ifsc).subscribe((d) => {
      if (!d || !d.branchId || this.form.value.ifscCode !== ifsc) { return; }
      this.bankcityService.getBank(this.form.value.state, true).subscribe((banks) => {
        this.bankName = banks.filter((i: { key: number }) => i.key);
        this.bankNameList = this.bankName;
        this.bankcityService.getCity(this.form.value.state, d.bankId, true).subscribe((cities) => {
          this.CityName = cities;
          this.filterCityName = cities;
          this.farmerService.getbranch(d.cityId, true).subscribe((branches) => {
            this.branchName = branches;
            this.filterbranchName = branches;
            this.form.patchValue({ bankName: d.bankId, City: d.cityId, branch: d.branchId });
          });
        });
      });
    });
  }

  keyUp(event) {}

  onKeyUp() {
    let loadamount = parseInt(this.form.value.subsidyAmount);
    if (loadamount > this.totalSubsidyAmount) {
      this.Amountvalid = true;
      this.lowSubsidy = false;
    } else if (loadamount < this.totalSubsidyAmount) {
      this.lowSubsidy = true;
      this.Amountvalid = false;
    } else {
      this.Amountvalid = false;
      this.lowSubsidy = false;
    }
  }
}
